import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'tpl-yes-or-not',
  templateUrl: './tpl-yes-or-not.component.html',
  styleUrls: ['./tpl-yes-or-not.component.sass']
})
export class TplYesOrNotComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() objColor: any;
  @Input() low_score_label: string;
  @Input() high_score_label: string;

  @Output() nextStep = new EventEmitter<string>();

  timer;

  constructor() { }

  ngOnInit(): void {
  }

  setFormValue(value){
    clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.nextStep.emit('');
    }, 1000);
    this.form.get('value').setValue(value);
  }

  hoverColor(id){
    let tag = document.getElementById(id);
    tag.classList.add("opacity");
  }

  outColor(id) {
    let tag = document.getElementById(id);
    tag.classList.remove("opacity");
  }

  clickColor(selected){
    const removeSelect = selected == 'yes' ? 'no' : 'yes';
    let clickRemove = document.getElementById(removeSelect);
    let clickAdd = document.getElementById(selected);
    clickRemove.classList.remove("click");
    clickAdd.classList.add("click");
  }
}
